import { subActivityList, subActivityUniqueList } from "constants/subActivity";

const initialState = {
  subActivityList: {},
  subActivityUniqueList: {},
};

const subActivity = (state = initialState, action) => {
  switch (action.type) {
    case subActivityList:
      return { ...state, subActivityList: action.payload };

    case subActivityUniqueList:
      return { ...state, subActivityUniqueList: action.payload };

    default:
      return state;
  }
};
export default subActivity;
